import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";


export const startLesson  = createAsyncThunk(
    "lessons/startLessonMeeting",
    async ( lessonsId: number | string | undefined, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const { token } = JSON.parse(authToken);

            const response = await axios.post(`/api/lessons/${lessonsId}/start-lesson`,
                null,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data.success) {
                return response.data;
            } else {
                console.error("Ошибка при завершении урока:", response.data.error);
                return thunkAPI.rejectWithValue(response.data.error);
            }
        } catch (error) {
            console.error("Произошла ошибка:", error);
            return thunkAPI.rejectWithValue("error");
        }
    }
);
